import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold border-b-2 md:pt-6 pt-8">Contact</p>
          <p className="py-6 text-center text-bold">Submit the form below to get in touch with me</p>
        </div>
        <div>
          <form action="https://getform.io/f/55f7376a-84a5-4421-89bc-024be93e960e" method="POST" className="flex flex-col w-full md:w-/2">
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-white"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="p-2 my-4 bg-transparent border-2 rounded-md text-white"
              required
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="p-2 bg-transparent border-2 rounded-md text-white"
            ></textarea>
            <button className="text-white bg-gradient-to-r from-violet-700 to-purple-500 rounded-md px-6 py-3 my-8 mx-auto flex items-center hover:scale-110 duration-300">
              Let's talk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
